import AIBlogWriter from "~/assets/png/ai-blog.png";
import AIAdsWriter from "~/assets/png/ai-ads-writer.png";
import AIWatermarkRemover from "~/assets/png/watermark_remover.png";
import AIBackgroundRemover from "~/assets/png/background_remover.png";
import AIModelPhotoshoots from "~/assets/png/modal_photoshoots.png";
import AIBackgroundGenerator from "~/assets/png/ai-background-generator.png";
import AIPhotoEnhancer from "~/assets/png/ai-photo-enhancer.png";
import AIContentWriter from "~/assets/png/ai-content-writer.png";
import AIVideoGenerator from "~/assets/png/ai-video-generator.png";
import { IFeature } from "~/types/feature";
import { paths } from "~/router/paths";
import { TFunction } from "i18next";
import { Limits } from "~/types/billing";

export const features: IFeature[] = [
  { name: "features.ai_blog_writer", img: AIBlogWriter, url: paths["blog-writer"]?.index || paths.blog.index },
  { name: "features.ai_ads_writer", img: AIAdsWriter, url: paths["ads-writer"]?.index || paths.ads.index },
  { name: "features.ai_watermark_remover", img: AIWatermarkRemover, url: paths["watermark-remover"]?.index || paths["watermark-remover"]?.index },
  { name: "features.ai_background_remover", img: AIBackgroundRemover, url: paths["background-remover"]?.index || paths["background-remover"]?.index },
  { name: "features.ai_models_photoshoot", img: AIModelPhotoshoots, url: paths["ai-models-photoshoot"]?.index || paths["ai-models-photoshoot"]?.index },
  { name: "features.ai_background_generator", img: AIBackgroundGenerator, url: paths["background-generator"]?.index || paths["background-generator"]?.index },
  { name: "features.ai_photo_enhancer", img: AIPhotoEnhancer, url: paths["photo-enhancer"]?.index || paths["photo-enhancer"]?.index },
  { name: "features.ai_content_humanizer", img: AIContentWriter, url: paths["content"]?.index || paths["content"]?.index },
  // { name: "features.ai_video_generator", img: AIVideoGenerator, url: paths["video-generator"]?.index || paths["video-generator"]?.index },
];

const translationKeys = {
  paid_plan: {
    titleWithAbovePlans: "features.paid_plan.title_with_above",
    title: "features.paid_plan.title",
    description: "features.paid_plan.description",
    testimonial: "features.paid_plan.testimonial",
  },
  premium_keywords:  {
    titleWithAbovePlans: "features.premium_keywords.title_with_above",
    title: "features.premium_keywords.title",
    description: "features.premium_keywords.description",
    testimonial: "features.premium_keywords.testimonial",
  },
  ads_writer: {
    titleWithAbovePlans: "features.ads_writer.title_with_above",
    title: "features.ads_writer.title",
    description: "features.ads_writer.description",
    testimonial: "features.ads_writer.testimonial",
  },
  blog_generated: {
    titleWithAbovePlans: "features.blog_generated.title_with_above",
    title: "features.blog_generated.title",
    description: "features.blog_generated.description",
    testimonial: "features.blog_generated.testimonial",
  },
  background_removal: {
    titleWithAbovePlans: "features.background_removal.title_with_above",
    title: "features.background_removal.title",
    description: "features.background_removal.description",
    testimonial: "features.background_removal.testimonial",
  },
  chat: {
    titleWithAbovePlans: "features.chat.title_with_above",
    title: "features.chat.title",
    description: "features.chat.description",
    testimonial: "features.chat.testimonial",
  },
  descriptions_generated: {
    titleWithAbovePlans: "features.descriptions_generated.title_with_above",
    title: "features.descriptions_generated.title",
    description: "features.descriptions_generated.description",
    testimonial: "features.descriptions_generated.testimonial",
  },
  generation_count_limit: {
    titleWithAbovePlans: "features.generation_count_limit.title_with_above",
    title: "features.generation_count_limit.title",
    description: "features.generation_count_limit.description",
    testimonial: "features.generation_count_limit.testimonial",
  },
  save_descriptions: {
    titleWithAbovePlans: "features.save_descriptions.title_with_above",
    title: "features.save_descriptions.title",
    description: "features.save_descriptions.description",
    testimonial: "features.save_descriptions.testimonial",
  },
} satisfies Record<
  Limits,
  {
    title: string;
    titleWithAbovePlans: string;
    description: string;
    testimonial: string;
  }
>;

export const planEmojis: Record<string, string> = {
  starter: "⭐",
  pro: "✨",
  empire: "👑",
  unicorn: "🦄"
};

export const getFeaturesTranslations = (
  t: TFunction,
  limitType: Limits,
  planName: string,
  hasAbovePlans: boolean
) => {
  const translations = translationKeys[limitType];

  return {
    title: t(
      hasAbovePlans ? translations.titleWithAbovePlans : translations.title,
      { planName }
    ),
    description: t(translations.description, { planName }),
    testimonial: t(translations.testimonial, { planName }),
  };
};
